import { useEffect } from "react";
import authApi from "../../../utils/api/authApi";
import { useNavigate } from "react-router-dom";
import { LOGIN } from "../../../enums/UrlPaths";
import { VERIFY } from "../../../enums/ApiPaths";

/**
 * User is redirected to this page after getting a verification link
 */
export default function VerifyPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const urlSearchString = window.location.search;
    const params = new URLSearchParams(urlSearchString);
    verifyRegistration(params.get("token"));
    navigate(LOGIN);
  }, []);

  async function verifyRegistration(token) {
    try {
      await authApi.post(VERIFY + "?token=" + token);
    } catch {}
  }
}
